import React, { useCallback, useContext, useMemo, useRef } from 'react';
import {
  EditSceneModalSlotsOverlayContextType,
  EditSceneModalSlotsOverlayProviderProps,
} from './types';

const EditSceneModalSlotsOverlayContext = React.createContext<
  EditSceneModalSlotsOverlayContextType | undefined
>(undefined);

/**
 * A context provider for the slots overlay.  One main use case it to collect all
 * of the slot refs so that they can be used for calculations in other parts of
 * the tree
 */
export const EditSceneModalSlotsOverlayProvider: React.FC<EditSceneModalSlotsOverlayProviderProps> = ({
  children,
}) => {
  const refs = useRef<React.RefObject<HTMLDivElement>[]>([]);

  const getOverlayRef = useCallback(
    (slotIndex: number) => {
      if (!refs.current[slotIndex]) {
        refs.current[slotIndex] = React.createRef<HTMLDivElement>();
      }

      return refs.current[slotIndex];
    },
    [refs],
  );

  return (
    <EditSceneModalSlotsOverlayContext.Provider
      value={useMemo(
        () => ({
          getOverlayRef,
        }),
        [getOverlayRef],
      )}
    >
      {children}
    </EditSceneModalSlotsOverlayContext.Provider>
  );
};

export const useEditSceneModalSlotsOverlayContext = () => {
  const context = useContext(EditSceneModalSlotsOverlayContext);

  if (!context) {
    throw new Error(
      'useEditSceneModalSlotsOverlayContext must be used within a EditSceneModalSlotsOverlayProvider',
    );
  }
  return context;
};
